var _defs, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGift = function SvgGift(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76.569,
    height: 77.658,
    viewBox: "0 0 76.569 77.658",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.527,
    y1: 0.054,
    x2: 0.683,
    y2: 0.878,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#ffc000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#ffc000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e19807"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Subtraction_8",
    x: 0,
    y: 24.516,
    width: 76.569,
    height: 53.142,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcc02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb9400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.527,
    y1: 0.054,
    x2: 0.683,
    y2: 0.878,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd2a78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#db1e4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc0f29"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_1243",
    x: 18.544,
    y: 25.882,
    width: 40.71,
    height: 39.791,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b75503",
    floodOpacity: 0.631
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12005",
    "data-name": "Group 12005",
    transform: "translate(5.519 1.396)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5.52, -1.4)",
    filter: "url(#Subtraction_8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_8-2",
    "data-name": "Subtraction 8",
    d: "M51.17,35.142H7.4a3.9,3.9,0,0,1-3.882-3.477L0,0H58.569L55.051,31.665A3.908,3.908,0,0,1,51.17,35.142ZM29.892,23.182l0,.007,5.929,3.692a1.408,1.408,0,0,0,.77.235,1.5,1.5,0,0,0,1.161-.576,1.457,1.457,0,0,0,.268-1.272l-1.672-6.821,5.321-4.53a1.428,1.428,0,0,0,.467-1.566,1.447,1.447,0,0,0-1.286-1.03l-6.965-.507-2.634-6.52a1.464,1.464,0,0,0-2.709,0l-2.626,6.52-6.962.507a1.458,1.458,0,0,0-1.291,1.026,1.434,1.434,0,0,0,.45,1.57l5.331,4.53-1.672,6.821a1.456,1.456,0,0,0,.267,1.272,1.478,1.478,0,0,0,1.152.566,1.424,1.424,0,0,0,.77-.225l5.929-3.692Z",
    transform: "translate(9 30.52)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M319.094,119.486H285.651a1.915,1.915,0,0,1-1.914-1.419l-1.171-5.289a1.822,1.822,0,0,1,1.914-2.109H346.1a1.824,1.824,0,0,1,1.916,2.109l-1.173,5.289a1.911,1.911,0,0,1-1.914,1.419H312.342",
    transform: "translate(-282.527 -91.677)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 4.881,
    cy: 11.715,
    rx: 4.881,
    ry: 11.715,
    transform: "matrix(0.587, -0.81, 0.81, 0.587, 8.698, 7.906)",
    fill: "none",
    stroke: "#ffcc02",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 11.715,
    cy: 4.881,
    rx: 11.715,
    ry: 4.881,
    transform: "translate(29.85 11.443) rotate(-25.407)",
    fill: "none",
    stroke: "#ffcc02",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5.52, -1.4)",
    filter: "url(#Path_1243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1243-2",
    "data-name": "Path 1243",
    d: "M316.351,125.228l-7.12-.524-2.692-6.661a1.491,1.491,0,0,0-2.769,0l-2.692,6.661-7.12.524a1.508,1.508,0,0,0-.857,2.655l5.45,4.632-1.711,6.978a1.5,1.5,0,0,0,2.245,1.646l6.062-3.789,6.062,3.789a1.5,1.5,0,0,0,2.245-1.646l-1.711-6.978,5.45-4.632a1.5,1.5,0,0,0-.844-2.655Zm0,0",
    transform: "translate(-266.25 -83.47)",
    stroke: "#ffe89b",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    fill: "url(#linear-gradient-3)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGift, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };